export default defineNuxtRouteMiddleware((to) => {
  // On a static SPA, this middleware runs before Clerk's JS has initialized.
  // We skip all redirect logic here and let the pages handle it via watchEffect
  // once isLoaded becomes true on the client.
  if (import.meta.server) return;
});
